export const RecommendationType = {
  Service: 'Service',
  Insurance: 'Insurance',
  RateShopper: 'RateShopper',
} as const;

export type RecommendationTypeValue = (typeof RecommendationType)[keyof typeof RecommendationType];
